import { render, staticRenderFns } from "./sabcold.vue?vue&type=template&id=2029ce33&"
import script from "./sabcold.vue?vue&type=script&lang=js&"
export * from "./sabcold.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports